<template>
    <div :class="backgroundStyle">
        <slot></slot>
    </div>
</template>

<script>

export default {
    name:'card',
    props: {
        // False for no background. String for style class
        background: {
            type: [Boolean, String], 
            default: false,
            required: false
        },
        padding: {
            type: Number,
            default: 3,
            required: false
        },
        borderColor: {
            type: String,
            default: 'default',
            required: false
        },
        borderRadius: {
            type: Boolean,
            default: true,
            required: false
        },
        borderSize: {
            type: Number,
            default: 1,
            required: false
        }
    },
    computed:{
        backgroundStyle: function () {
            let style = this.background ? `${this.background}-bkg` : 'no-background'
            style += ` p-${this.padding}`
            style += ` b-${this.borderSize}-${this.borderColor}`
            style += this.borderRadius ? ` br` : ''
            return style
        }
    }
}
</script>
